import { AutogenLayoutDriverManagerProfile } from "./autogen/AutogenLayoutDriverManagerProfile";

export class DriverManagerProfile extends AutogenLayoutDriverManagerProfile {
    onLoad(): void | Promise<void> {
        this.layoutProfileColor.profileDataSource = this.mainDataSource;
    }
}
